import { Provider } from '@angular/core';
import {
  CreateDataSourcesUseCase,
  DeleteValueDataSourceUseCase,
  GetDataSourceFromJPUseCase,
  GetDetailDataSourcesUseCase,
  GetListDataSourcesUseCase,
  GetValueSystemDataSourceUseCase,
  UpdateDataSourcesUseCase,
  UpdateStatusDataSourceUseCase,
} from '@app/application/use-cases/data-sources';
import { DataSourcesRepository } from '@app/domain';
import { DataSourcesRepositoryImpl } from '../repositories';

export const DATA_SOURCE_PROVIDERS: Provider[] = [
  // Repositories
  {
    provide: DataSourcesRepository,
    useClass: DataSourcesRepositoryImpl,
  },
  {
    provide: GetListDataSourcesUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new GetListDataSourcesUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },

  {
    provide: UpdateDataSourcesUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new UpdateDataSourcesUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },

  {
    provide: CreateDataSourcesUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new CreateDataSourcesUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },

  {
    provide: UpdateStatusDataSourceUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new UpdateStatusDataSourceUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },
  {
    provide: DeleteValueDataSourceUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new DeleteValueDataSourceUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },
  {
    provide: GetDataSourceFromJPUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new GetDataSourceFromJPUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },
  {
    provide: GetDetailDataSourcesUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new GetDetailDataSourcesUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },
  {
    provide: GetValueSystemDataSourceUseCase,
    useFactory: (dataSourcesRepo: DataSourcesRepository) =>
      new GetValueSystemDataSourceUseCase(dataSourcesRepo),
    deps: [DataSourcesRepository],
  },
];
